(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class StickyBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.bar = document.getElementById('shopify-section-announcement-bar');
      this.barBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideBarOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventBarReveal', this.hideBarOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventBarReveal', this.hideBarOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.barBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.bar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.barBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.barBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.barBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.bar.classList.add('shopify-section-announcement-bar-hidden', 'shopify-section-announcement-bar-sticky');
    }

    reveal() {
      this.bar.classList.add('shopify-section-announcement-bar-sticky', 'animate');
      this.bar.classList.remove('shopify-section-announcement-bar-hidden');
    }

    reset() {
      this.bar.classList.remove('shopify-section-announcement-bar-hidden', 'shopify-section-announcement-bar-sticky', 'animate');
    }
  }

  customElements.define('sticky-bar', StickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendation"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              let swiper = new Swiper(".cart-recommendation_slider .mySwiper", {
                slidesPerView: "auto",
                slidesPerGroup: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: ".cart.carousel-button-next",
                  prevEl: ".cart.carousel-button-prev",
                },
                breakpoints: {
                  750: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 10,
                  },
                  1158: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 10,
                  },
                }
              });
            }

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('scroll', this.fadeBetweenLogos);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    fadeBetweenLogos() {
      const checkpoint = 200;
      const currentScroll = window.pageYOffset;
      let opacity = 0;
      let logo = document.querySelector(".header__heading-logo.large-up-hide");
      let logoMobile = document.querySelector(".header__heading-logo__mobile");

      if (logoMobile) {
        // Show desktop logo
        if (currentScroll <= checkpoint) {
          opacity = 1 - currentScroll / checkpoint;
        } else {
          opacity = 0;
        }

        if (logo) logo.style.opacity = opacity;

        // Show mobile logo
        if (currentScroll >= checkpoint) {
          opacity = 1.5 - checkpoint / currentScroll;
        } else {
          opacity = 0;
        }

        if (logoMobile) logoMobile.style.opacity = opacity;
      } else {
        // Only display desktop logo
        opacity = 1;
        if (logo) logo.style.opacity = opacity;
      }

    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  const imageMedias = document.querySelectorAll(".image-with-text__media");

  if(imageMedias != '') {
    function linkClick(event) {
      const media = event.target.closest('.image-with-text__media');
      const mediaPoster = media.querySelector('.video-section__poster');
      const isTextSelected = window.getSelection().toString();
      if(mediaPoster) {
        // for vimeo video
        if(mediaPoster.dataset.videotype === 'vimeo'){
          BigPicture({
            el: event.target,
            vimeoSrc: mediaPoster.dataset.videoid,
          })
        }

        // for youtube video
        if(mediaPoster.dataset.videotype === 'youtube'){
          BigPicture({
            el: event.target,
            ytSrc: mediaPoster.dataset.videoid,
          })
        }
      } else if (!isTextSelected && media && media.dataset.href != undefined) {
          window.location.href = media.dataset.href;
      }

    };

    imageMedias.forEach(media => {
      media.addEventListener("click", linkClick);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]`).forEach((element) => {
          element.classList.remove('hidden');
        }
      )
      
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
          element.classList.add('hidden');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-offer-tiles"] && !Shopify.designMode) return;
  try {
    
// Global Function to take click from Legal Link to show and hide the "Disclaimer" copy as well as adjust the link text.
window.termsClick = function (item, elem_txt) {
  const cElem = item.parentNode.parentNode.querySelector('.disclaimer');
  cElem.toggle();

  if (item.textContent == elem_txt) {
    item.textContent = "Close";
  }
  else {
    item.textContent = elem_txt;
  }
};

// Target all the elements with the 'data-channel' tag
const offerElems = document.querySelectorAll('[data-channel]');

// Target the filter buttons with the 'tglbtn' class
const filterBtns = document.querySelectorAll('.tglbtn ');

// Loop through each 'tglbtn' element and add a click listener
filterBtns.forEach(element => {
  element.addEventListener('click', function(event) {
    filterBtns.forEach(element => {
      element.classList.remove('active');
    });
    if (this.dataset.toggle == 'all') {
      this.classList.add('active');
      offerElems.forEach(element => {
        element.fadeIn();
      });
    } else if (this.dataset.toggle == 'online') {
      this.classList.add('active');
      offerElems.forEach(element => {
        if (element.dataset.channel == 'online' && element.checkVisibility() == false) {
          element.fadeIn();
        } else if (element.dataset.channel == 'store') {
          element.fadeOut();
        }
      });
    } else if (this.dataset.toggle == 'store') {
      this.classList.add('active');
      offerElems.forEach(element => {
        if (element.dataset.channel == 'store' && element.checkVisibility() == false) {
          element.fadeIn();
        } else if (element.dataset.channel == 'online') {
          element.fadeOut();
        }
      });
    }
  });
});

// ** TOGGLE DISPLAY FUNCTION **
HTMLElement.prototype.toggle = function() {
  if(this.style.display === 'none') {
    this.fadeIn();
  } else {
    this.fadeOut();
  }
}

HTMLElement.prototype.fadeIn = function(display) {
  _fadeIn(this, display)
}

HTMLElement.prototype.fadeOut = function() {
  _fadeOut(this)
}

// ** FADE OUT FUNCTION **
function _fadeOut(el) {
  el.style.opacity = 1;
  (function fade() {
    if ((el.style.opacity -= 0.025) < 0) {
        el.style.display = "none";
    } else {
      requestAnimationFrame(fade);
    }
  })();
};

// ** FADE IN FUNCTION **
function _fadeIn(el, display) {
  el.style.opacity = 0;
  el.style.display = display || "block";
  (function fade() {
    var val = parseFloat(el.style.opacity);
    if (!((val += 0.025) > 1)) {
      el.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
class TabsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.tabs = document.querySelector('tabs-disclosure');
    this.tabButtons = this.tabs.querySelectorAll('[role="tab"]');
    this.tabPanels = this.tabs.querySelectorAll('[role="tabpanel"]');
    this.tabButtons.forEach(button => button.addEventListener('click', this.handleTabClick.bind(this)));


    if (this.tabPanels[0]) {
      this.tabPanels[0].hidden = false;
      this.tabButtons[0].setAttribute('aria-selected', true);
      this.tabButtons[0].classList.add('active');
    }
  }

  handleTabClick(event) {
    this.tabPanels.forEach(panel => {
        panel.hidden = true;
      });

      this.tabButtons.forEach(tab => {
        tab.setAttribute('aria-selected', false);
        tab.classList.remove('active');
      });
      event.currentTarget.setAttribute('aria-selected', true);
      event.currentTarget.classList.add('active');
      const { id } = event.currentTarget;
      const tabPanel = this.tabs.querySelector(`[aria-labelledby="${id}"]`);
      tabPanel.hidden = false;
  }
}

customElements.define('tabs-disclosure', TabsDisclosure);

class ViewMore extends HTMLElement {
  constructor() {
  super();
  this.viewMoreText = this.querySelector('[role="clampText"]');
  this.viewMoreButton = this.querySelector('[role="moreButton"]');
  this.viewMoreButton.addEventListener('click', this.handleViewMoreClick.bind(this));
  this.initViewMore();
  window.addEventListener('resize', this.initViewMore.bind(this));
  window.addEventListener('orientationchange', this.initViewMore.bind(this));
  }

  initViewMore() {
  let clientHeight = this.offsetHeight;
  let isClamped = clientHeight > maxTextHeight;

    if (isClamped) {
    this.viewMoreText.classList.remove("expanded-text");
    this.viewMoreText.classList.add("clamped-text");
    this.viewMoreButton.style.display = 'block';
    this.viewMoreText.style.height = maxTextHeight + 'px';
    } else {
    this.viewMoreText.classList.remove("clamped-text");
    this.viewMoreText.classList.add("expanded-text");
    this.viewMoreButton.style.display = 'none';
    this.viewMoreText.style.height = 'auto';
    }
    }

  handleViewMoreClick(event) {
  event.preventDefault();
  event.stopImmediatePropagation();

    if (this.viewMoreText.classList.contains("clamped-text")) {
    this.viewMoreButton.textContent = "View Less";
    this.viewMoreText.classList.remove("clamped-text");
    this.viewMoreText.classList.add("expanded-text");
    this.viewMoreText.style.height = 'auto';
    } else {
    this.viewMoreButton.textContent = "View More";
    this.viewMoreText.classList.remove("expanded-text");
    this.viewMoreText.classList.add("clamped-text");
    this.viewMoreText.style.height = maxTextHeight + 'px';
    }
    }
}

// customElements.define('view-more', ViewMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      //Handle href click event
      //SetTimeout to wait for recc prod object to load in
      setTimeout(() => {
        let cardInners = document.querySelectorAll(".card__inner");

        cardInners.forEach(card => {
          card.addEventListener("click", handleCardClick);
        });
      }, 500);

      function handleCardClick(event) {
        let target = event.target.closest(".card__inner");
        let isTextSelected = window.getSelection().toString();

        if (!isTextSelected && target && target.dataset.href != '') {
          window.location.href = target.dataset.href;
        }
      };

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class FeatureSlider extends HTMLElement {
    constructor() {
      super();

      window.addEventListener('load', this.initCarousel.bind(this));

      this.contentWrapper = this.closest(".feature-diagram__inner-wrapper");
      this.featureButtons =  this.contentWrapper.querySelectorAll('.feature-diagram__feature-selector');
      this.sectionId = this.dataset.sectionId;

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.initCarousel.bind(this));
        document.addEventListener('shopify:block:select', (event) => {
          const { blockId, sectionId } = event.detail;

          if (this.dataset.sectionId === sectionId) {
            const block = this.querySelector(`#block-${blockId}`);

            if (block) {
              const index = block.dataset.index;

              if (index) {
                this.flkty.select(parseInt(index));
              }
            }
          }
        })
      }
    }

    initCarousel() {
      this.swiper = new Swiper(".feature-diagram__feature-slider .mySwiper", {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".shop-the-look.carousel-button-next",
          prevEl: ".shop-the-look.carousel-button-prev",
        }
      });
    }
  }

  customElements.define('feature-slider', FeatureSlider);

  } catch(e) { console.error(e); }
})();
})();
